import { Engine, Actor, Color, Vector, CollisionType, Animation, SpriteSheet, vec } from 'excalibur';
import { Resources } from '../../resources';
import { collision_groups } from '../../scenes/level-one/collision_groups';
import { LevelOne } from '../../scenes/level-one/level-one';
import { range } from '../../util';
import { Enemy } from './enemy';

export class Shark extends Enemy {
    constructor(
        level: LevelOne,
    ) {
        super(
            level,
            200,
            3,
            Animation.fromSpriteSheet(
                SpriteSheet.fromImageSource({
                    image: Resources.sharkSide,
                    grid: {
                        rows: 3,
                        columns: 5,
                        spriteWidth: 680,
                        spriteHeight: 260,
                    },

                }),
                range(0, 14),
                57
            ),
            Animation.fromSpriteSheet(
                SpriteSheet.fromImageSource({
                    image: Resources.sharkTop,
                    grid: {
                        rows: 3,
                        columns: 4,
                        spriteWidth: 325,
                        spriteHeight: 564,
                    },

                }),
                range(0, 11),
                40
            )
        );
    }
}

export { Enemy }
